var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2343_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3609 5.33284L7.07245 3.50812C6.94874 3.48493 6.82503 3.50812 6.70132 3.55451L1.66789 5.47974C1.37408 5.58799 1.18079 5.87407 1.18079 6.19107V19.2501C1.18079 19.5672 1.37408 19.8455 1.66016 19.9537L6.69359 21.9254C6.77864 21.9563 6.87915 21.9795 6.97193 21.9795C7.00286 21.9795 7.03379 21.9795 7.06471 21.9795L14.2863 21.0671C14.4873 21.0439 14.6651 20.9357 14.7888 20.7811C14.9125 20.6187 14.9667 20.4254 14.9435 20.2244C14.9203 20.0233 14.812 19.8378 14.6496 19.7141C14.4873 19.5903 14.294 19.5362 14.093 19.5672L7.72192 20.3713V5.12408L20.4949 6.7555V13.1652C20.4949 13.5827 20.8351 13.9229 21.2526 13.9229C21.6702 13.9229 22.0104 13.5827 22.0104 13.1652V6.08283C22.0104 5.70397 21.7243 5.37923 21.3454 5.33284H21.3609ZM6.21421 5.36376V20.1084L5.18588 19.7063V5.75809L6.21421 5.36376ZM3.66271 6.33798V19.1032L2.70396 18.7244V6.7091L3.66271 6.33798Z",
    fill: "#6994BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69604 7.49014V17.99C8.69604 18.4075 9.03625 18.7477 9.45376 18.7477C9.87128 18.7477 10.2115 18.4075 10.2115 17.99V7.49014C10.2115 7.07262 9.87128 6.73242 9.45376 6.73242C9.03625 6.73242 8.69604 7.07262 8.69604 7.49014Z",
    fill: "#6994BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0826 7.93057V17.5644C12.0826 17.982 12.4228 18.3222 12.8404 18.3222C13.2579 18.3222 13.5981 17.982 13.5981 17.5644V7.93057C13.5981 7.51305 13.2579 7.17285 12.8404 7.17285C12.4228 7.17285 12.0826 7.51305 12.0826 7.93057Z",
    fill: "#6994BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2346 7.59863C15.8171 7.59863 15.4769 7.93883 15.4769 8.35635V11.3486C15.4769 11.7661 15.8171 12.1063 16.2346 12.1063C16.6522 12.1063 16.9924 11.7661 16.9924 11.3486V8.35635C16.9924 7.93883 16.6522 7.59863 16.2346 7.59863Z",
    fill: "#6994BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.366 8C18.9485 8 18.6083 8.3402 18.6083 8.75772V12.4303C18.6083 12.8479 18.9485 13.1881 19.366 13.1881C19.7835 13.1881 20.1237 12.8479 20.1237 12.4303V8.75772C20.1237 8.3402 19.7835 8 19.366 8Z",
    fill: "#6994BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8531 20.0693L19.9691 17.1853L21.3454 15.8091C21.7629 15.3915 21.6392 14.9199 21.0671 14.7653L15.129 13.1725C14.5568 13.0179 14.2089 13.3658 14.3636 13.938L15.9563 19.876C16.1109 20.4482 16.5826 20.5719 17.0001 20.1544L18.3764 18.7781L21.2604 21.6621C21.4536 21.8554 21.7629 21.8554 21.9562 21.6621L22.8608 20.7574C23.0541 20.5641 23.0541 20.2549 22.8608 20.0616L22.8531 20.0693Z",
    fill: "#6994BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2343_1698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.8192,
    height: 18.4791,
    fill: "white",
    transform: "translate(1.18079 3.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.18538c09c270848d8ab375da72ef02f1.svg";
export { ForwardRef as ReactComponent };